module.exports = __webpack_public_path__ + "media/palenque/waterfall4-34890e27.jpg";